"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.byteRangeToString = exports.compareByteRanges = exports.getByteRange = void 0;
function getByteRange(context) {
    return context.rangeEnd && context.rangeStart !== undefined
        ? { offset: context.rangeStart, length: context.rangeEnd - context.rangeStart }
        : undefined;
}
exports.getByteRange = getByteRange;
function compareByteRanges(b1, b2) {
    return b1 === undefined ? b2 === undefined : b2 !== undefined && b1.length === b2.length && b1.offset === b2.offset;
}
exports.compareByteRanges = compareByteRanges;
function byteRangeToString(byteRange) {
    if (byteRange === undefined) {
        return undefined;
    }
    const end = byteRange.offset + byteRange.length - 1;
    return `bytes=${byteRange.offset}-${end}`;
}
exports.byteRangeToString = byteRangeToString;
